import { useSelector } from 'react-redux'

export const getPreSeasonActivityParticipants = (activityTitle) => {
  const { activityCount } = useSelector((state) => state.newPreSeasonActivity)
  return activityCount?.find((activity) => activity.title === activityTitle)
}
